import ChatActions from "../../actions/ChatActions";
import alt from "../../alt/ChatAlt";

const SLIDER_TIMER = 3600;

class PotentialExpertsStore {
    constructor() {
        this.bindActions(ChatActions);
        this.bindListeners({
            handleReset: [ChatActions.resetChat],
        });
        this.handleReset();
    }

    handleReset() {
        this.error = null;
        this.experts = [];
        this.indexes = {
            prevExpert: 0,
            currentExpert: 1,
            nextExpert: 2,
        };
        this.isLoading = true;
        this.lastResponseTimeInMillis = undefined;
        clearInterval(this.timer);
        this.timer = null;
    }

    onLoadPotentialExperts() {
        this.handleReset();
    }

    onLoadPotentialExpertsFail(payload) {
        this.error = payload.error;
        this.isLoading = false;
    }

    onLoadPotentialExpertsSuccess(payload) {
        this.error = null;
        this.experts = payload.experts;
        this.isLoading = false;
        this.lastResponseTimeInMillis = payload.lastResponseTimeInMillis;
        if (this.experts.length === 1) {
            this.indexes = {
                prevExpert: -1,
                currentExpert: 0,
                nextExpert: -1,
            };
        }
        if (this.experts.length > 1) {
            this.onCyclePotentialExperts();
        }
    }

    onCyclePotentialExperts() {
        const expertCount = this.experts.length - 1;

        clearInterval(this.timer);
        this.timer = setInterval(() => {
            const { currentExpert, nextExpert, prevExpert } = this.indexes;

            this.indexes.currentExpert = currentExpert === expertCount ? 0 : currentExpert + 1;
            this.indexes.nextExpert = nextExpert === expertCount ? 0 : nextExpert + 1;
            this.indexes.prevExpert = prevExpert === expertCount ? 0 : prevExpert + 1;
            this.emitChange();
        }, SLIDER_TIMER);
        this.preventDefault();
    }

    onClearPotentialExpertsTimer() {
        clearInterval(this.timer);
    }

    static getExperts() {
        return this.getState().experts;
    }

    static getCurrentExpert() {
        return this.getState().experts[this.getState().indexes.currentExpert];
    }
}

export default alt.createStore(PotentialExpertsStore, "PotentialExpertsStore");
